import { createStore } from "effector"
import { useUnit } from "effector-react"
import { IFrameEvents } from "./IFrameEvents"
import {
  $startupConfigurationStore,
  amnVendor,
  languageLineVendor,
  setStartupConfiguration,
  type StartupConfiguration,
} from "../../pages/stores/startupConfiguration"
import { initLanguageLineIFrameEvents } from "./languageLine"
import { initAmnIFrameEvents } from "./amn"
import { clearStores } from "../../pages/stores/clearStores"

export const initIFrameEventsForStartupConfig = ({
  ui_profile,
}: StartupConfiguration): IFrameEvents | null => {
  switch (ui_profile.vendor) {
    case languageLineVendor:
      return initLanguageLineIFrameEvents(ui_profile)
    case amnVendor:
      return initAmnIFrameEvents(ui_profile)
    default:
      break
  }

  // In the past, we used enable_status_events as a flag to enable events for
  // LanguageLine. We'll still fallback to checking this flag to handle the
  // period where the new "vendor" property may not yet be available.
  if (ui_profile.enable_status_events) {
    return initLanguageLineIFrameEvents(ui_profile)
  }

  return null
}

const getInitialIFrameEventsValue = () => {
  const startupConfig = $startupConfigurationStore.getState()
  if (!startupConfig) return null
  return initIFrameEventsForStartupConfig(startupConfig)
}

const $iframeEvents = createStore<IFrameEvents | null>(
  getInitialIFrameEventsValue()
)
  .on(setStartupConfiguration, (state, startupConfig) => {
    state?.dispose?.()
    return initIFrameEventsForStartupConfig(startupConfig)
  })
  .on(clearStores, (state) => {
    state?.dispose?.()
    return null
  })

type UseIFrameEventsResult = {
  iframeEvents: IFrameEvents | undefined
}

export const useIFrameEvents = (): UseIFrameEventsResult => {
  const iframeEvents = useUnit($iframeEvents) ?? undefined
  return { iframeEvents }
}
